import React from "react";

import { clsx } from "clsx";

import { withHero } from "./withHero";
import HeroImage from "./HeroImage";
import { StyledContainer } from "../../Styled/Container";

const Container = (props: any) => (
  <StyledContainer
    {...props}
    className={clsx(props.className, "flex flex-wrap bg-neutral-alt")}
  />
);

const Hero = withHero(({ items, onClickImage }) => {
  return (
    <Container width="full">
      {items?.map((item, index) => (
        <HeroImage
          key={index}
          image={item.image}
          onClickImage={onClickImage}
          imageLink={item.imageLink}
          link={item.link}
        />
      ))}
    </Container>
  );
});

export default Hero;
